import { Document, pdf } from '@react-pdf/renderer';
import middleware from '../Api/Middleware';
import PickPDFPages from './PackingSlipPdf';
import ToastPromise from '../Toasts/ToastPromise';

export const generatePackingSlip = async (orderIds, print = false) => {
    return await ToastPromise({
        promise: (async () => {
            const formattedOrderIds = orderIds.map((id) => ({ order_id: id }));

            const response = await middleware.get(`orders/packingslips`, {
                params: { orders: formattedOrderIds },
            });

            const orders = response.data.data.orders;
            const companyInfo = response.data.data.company_info;

            if (!window.Buffer) {
                const { Buffer } = await import('buffer');
                window.Buffer = Buffer;
            }

            const pages = [];
            let successCount = 0;
            
            for (const order of orders) {
                pages.push(<PickPDFPages key={order.order.order_id} packingSlipData={order} companyInfo={companyInfo} />);
                successCount++;
            }

            if (pages.length === 0) {
                throw new Error('Geen pakbonnen konden worden gegenereerd.');
            }

            const pdfDoc = <Document>{pages}</Document>;
            const pdfBlob = await pdf(pdfDoc).toBlob();
            const url = URL.createObjectURL(pdfBlob);
            const printWindow = window.open(url, '_blank');
            if (print && printWindow) { // Open the printing dialog
                printWindow.onload = () => {
                    printWindow.print();
                };
            }
            setTimeout(() => URL.revokeObjectURL(url), 100);

            return {
                success: true,
                successCount,
                message: `${successCount} pakbon(nen) succesvol gegenereerd.`,
            };
        })(),
        pending: 'Pakbonnen genereren…',
        successRenderer: (data) => data?.message || 'Pakbonnen succesvol gegenereerd',
        errorRenderer: (error) =>
            error?.response?.data?.message ||
            error?.message ||
            'Er is een fout opgetreden bij het genereren van de pakbonnen',
        autoClose: 5000,
    });
};

export default generatePackingSlip;
